/* eslint-disable */
import Actions from "./action-types";

const {
  ASSESMENT_CHANGED,
  FETCH_FAIL,
  PREV_SCREEN_SUCCESS,
  PREV_SCREEN_FAILED,
  FIELD_CHANGED,
  INITIALIZE_FLOW,
  INITIALIZE_SCREEN,
  INITIALIZE_SCREEN_PREV,
  SHOW_GLOBAL_DIALOG,
  PHARMACIES_FOUND,
  CAPSULE_PHARMACY_FOUND,
  PICK_PHARMACY_ON_MAP,
  SET_FILTERS,
  RESET_FILTERS,
  SET_DETAIL_PROVIDER_DATA,
  RESET_DETAIL_PROVIDER_DATA,
  SET_DETAIL_PROVIDER_FIELDS_DATA,
  CARE_TEAM_SET_DETAIL_PROVIDER_FIELDS_DATA,
  SET_TREATMENT_DATA,
  DELETE_TREATMENT_DATA,
  UPDATE_TREATMENT_DATA,
  RESET_TREATMENT_DATA,
  SET_TREATMENT_TO_EDIT,
  RESET_TREATMENT_TO_EDIT,
  RESET_STATE,
  SET_STATE,
  DELETE_FROM_STATE,
  SET_VALIDATION,
  RESET_VALIDATION,
  ADD_TOAST,
  REMOVE_TOAST,
  SET_FIELD_VALIDATION,
  RESET_FIELD_VALIDATION,
  RESET_FIELDS_VALIDATION,
  RESET_FIELD_VALIDATION_ALL,
  DEPENDENT_STORED_SUCCESS,
  RESET_DEPENDENT,
  CARE_RECIPIENT_STORED_SUCCESS,
  RESET_CARE_RECIPIENT,
  ADD_TRACKING_EVENT,
  RESET_TRACKING_EVENTS,
  SET_SCREEN_PARAMS,
  SET_FORM_GROUP_ERRORS,
  RESET_STORE,
  SET_SELECTED_DATE,
  SET_SELECTED_TIME,
  CLEAR_DATE_TIME_SELECTION,
  ADD_CALL_TO_ACTION_BUTTON_IS_LOADING,
  REMOVE_CALL_TO_ACTION_BUTTON_IS_LOADING,
  LOADING,
  SET_SHOW_HUD,
  RESET_SHOW_HUD,
  SET_SETTINGS,
  INITIALIZE_DIALOG,
  CLEAR_DIALOG_FLOW,
  RESET_ACTION_FIELD,
  SET_FORM_ERRORS_FROM_BACK,
  PII_COLLECTED_SUCCESS,
  SET_PAGE_NUMBER,
  SET_SELECTED_LIST_ITEM,
  RESET_FORM_FIELDS,
  ITEM_SELECTED,
  RESET_ITEM_SELECTED,
  LOADED
} = Actions;

export const setFlowStatusLoading = () => ({
  type: LOADING
});

export const setFlowStatusLoaded = () => ({
  type: LOADED
});

export const fetchFlowFailed = error => ({
  type: FETCH_FAIL,
  payload: { error }
});

export const initializeFlow = payload => ({
  type: INITIALIZE_FLOW,
  payload
});

export const setGlobalDialog = payload => ({
  type: SHOW_GLOBAL_DIALOG,
  payload: { screenParams: { dialogConfig: payload } }
});

export const initializeScreen = payload => ({
  type: INITIALIZE_SCREEN,
  payload
});

export const initializePrevScreen = payload => ({
  type: INITIALIZE_SCREEN_PREV,
  payload
});

export const fieldChanged = payload => ({
  type: FIELD_CHANGED,
  payload
});

export const assesmentChanged = payload => ({
  type: ASSESMENT_CHANGED,
  payload
});

export const prevScreenSuccess = payload => ({
  type: PREV_SCREEN_SUCCESS,
  payload
});

export const prevScreenFailed = payload => ({
  type: PREV_SCREEN_FAILED,
  payload
});

export const pharmaciesFound = payload => ({
  type: PHARMACIES_FOUND,
  payload
});

export const capsulePharmacyDelivery = payload => ({
  type: CAPSULE_PHARMACY_FOUND,
  payload
});

export const pickPharmacyOnMap = payload => ({
  type: PICK_PHARMACY_ON_MAP,
  payload
});

export const setFilters = (filters, providers) => ({
  type: SET_FILTERS,
  filters,
  providers
});

export const resetFilters = filters => ({
  type: RESET_FILTERS,
  filters
});

export const resetFormState = payload => ({
  type: RESET_STATE,
  payload
});

export const setFormState = payload => ({
  type: SET_STATE,
  payload
});

export const deleteFromFormState = payload => ({
  type: DELETE_FROM_STATE,
  payload
});

export const resetFormFields = payload => ({
  type: RESET_FORM_FIELDS,
  payload
});

export const setDetailProviderData = payload => ({
  type: SET_DETAIL_PROVIDER_DATA,
  payload
});

export const resetDetailProviderData = () => ({
  type: RESET_DETAIL_PROVIDER_DATA
});

export const setDetailProviderFieldsData = payload => ({
  type: SET_DETAIL_PROVIDER_FIELDS_DATA,
  payload
});

export const setDetailCareTeamProviderFieldsData = payload => ({
  type: CARE_TEAM_SET_DETAIL_PROVIDER_FIELDS_DATA,
  payload
});

export const setTreatmentData = payload => ({
  type: SET_TREATMENT_DATA,
  payload
});

export const deleteTreatmentData = payload => ({
  type: DELETE_TREATMENT_DATA,
  payload
});

export const updateTreatmentData = payload => ({
  type: UPDATE_TREATMENT_DATA,
  payload
});

export const resetTreatmentData = () => ({
  type: RESET_TREATMENT_DATA
});

export const setTreatmentToEdit = payload => ({
  type: SET_TREATMENT_TO_EDIT,
  payload
});

export const resetTreatmentToEdit = () => ({
  type: RESET_TREATMENT_TO_EDIT
});

export const setValidation = validation => ({
  type: SET_VALIDATION,
  payload: validation
});

export const resetValidation = () => ({
  type: RESET_VALIDATION
});

export const addToast = toast => ({
  type: ADD_TOAST,
  payload: toast
});

export const removeToast = toastId => ({
  type: REMOVE_TOAST,
  payload: toastId
});

export const setFieldValidation = fieldValidation => ({
  type: SET_FIELD_VALIDATION,
  payload: fieldValidation
});

export const resetFieldValidation = fieldName => ({
  type: RESET_FIELD_VALIDATION,
  payload: fieldName
});

export const resetFieldsValidation = () => ({
  type: RESET_FIELDS_VALIDATION
});

export const resetFieldValidationAll = () => ({
  type: RESET_FIELD_VALIDATION_ALL
});

export const dependentStoredSuccess = () => ({
  type: DEPENDENT_STORED_SUCCESS
});

export const resetDependent = () => ({
  type: RESET_DEPENDENT
});

export const careRecipientStoredSuccess = () => ({
  type: CARE_RECIPIENT_STORED_SUCCESS
});

export const resetCareRecipient = () => ({
  type: RESET_CARE_RECIPIENT
});

export const addTrackingEvent = event => ({
  type: ADD_TRACKING_EVENT,
  payload: event
});

export const resetTrackingEvents = () => ({
  type: RESET_TRACKING_EVENTS
});

export const setScreenParams = payload => ({
  type: SET_SCREEN_PARAMS,
  payload
});

export const setFormGroupErrors = payload => ({
  type: SET_FORM_GROUP_ERRORS,
  payload
});

export const resetReduxStore = () => ({
  type: RESET_STORE
});

export const clearDateTimeSelection = () => ({
  type: CLEAR_DATE_TIME_SELECTION
});

export const setSelectedDate = selectedDate => ({
  type: SET_SELECTED_DATE,
  payload: {
    selectedDate
  }
});

export const setSelectedTime = selectedTime => ({
  type: SET_SELECTED_TIME,
  payload: {
    selectedTime
  }
});

export const onItemSelected = selected => ({
  type: ITEM_SELECTED,
  payload: selected
});

export const resetItemSelected = () => ({
  type: RESET_ITEM_SELECTED
});

export const addCallToActionButtonIsLoading = payload => ({
  type: ADD_CALL_TO_ACTION_BUTTON_IS_LOADING,
  payload
});

export const removeCallToActionButtonIsLoading = payload => ({
  type: REMOVE_CALL_TO_ACTION_BUTTON_IS_LOADING,
  payload
});

export const setShowHud = () => ({
  type: SET_SHOW_HUD
});

export const resetShowHud = () => ({
  type: RESET_SHOW_HUD
});

export const setSettings = payload => ({
  type: SET_SETTINGS,
  payload
});

export const initializeDialog = () => ({
  type: INITIALIZE_DIALOG
});

export const clearDialogFlow = payload => ({
  type: CLEAR_DIALOG_FLOW,
  payload
});

export const resetActionField = payload => ({
  type: RESET_ACTION_FIELD,
  payload
});

export const setFormErrorsFromBack = payload => ({
  type: SET_FORM_ERRORS_FROM_BACK,
  payload
});

export const piiCollectedSuccess = () => ({
  type: PII_COLLECTED_SUCCESS
});

export const setPageNumber = payload => ({
  type: SET_PAGE_NUMBER,
  payload
});

export const setSelectedListItem = payload => ({
  type: SET_SELECTED_LIST_ITEM,
  payload
});
